"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKpiData = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var converters_1 = require("../../../../converters");
var model_1 = require("../../../../model");
var common_1 = require("../../common");
/**
 * @internal
 */
function useKpiData(_a) {
    var kpiWidget = _a.kpiWidget, dashboardFilters = _a.dashboardFilters;
    var _b = common_1.useWidgetFilters(kpiWidget), status = _b.status, result = _b.result, error = _b.error;
    // we only put IDashboardFilters in, so we must get IDashboardFilters out as well
    var effectiveFilters = result;
    var dateDatasetsMap = model_1.useDashboardSelector(model_1.selectAllCatalogDateDatasetsMap);
    if (!kpiWidget || status === "pending") {
        return {
            status: "pending",
            error: undefined,
            result: undefined,
        };
    }
    if (status === "error") {
        return {
            status: "error",
            error: error,
            result: undefined,
        };
    }
    if (status === "rejected") {
        return {
            status: "error",
            error: new sdk_ui_1.UnexpectedSdkError("Getting filter settings for a KPI widget failed."),
            result: undefined,
        };
    }
    if (status === "running") {
        return {
            status: "loading",
            error: undefined,
            result: undefined,
        };
    }
    var allFilters = converters_1.filterContextItemsToDashboardFiltersByWidget(dashboardFilters, kpiWidget);
    var primaryMeasure = sdk_model_1.newMeasure(kpiWidget.kpi.metric);
    var secondaryMeasure = getSecondaryMeasure(kpiWidget, primaryMeasure, effectiveFilters, dateDatasetsMap);
    return {
        status: "success",
        error: undefined,
        result: { primaryMeasure: primaryMeasure, secondaryMeasure: secondaryMeasure, effectiveFilters: effectiveFilters, allFilters: allFilters },
    };
}
exports.useKpiData = useKpiData;
function getSecondaryMeasure(kpiWidget, primaryMeasure, effectiveFilters, dateDatasetsMap) {
    var comparison = kpiWidget.kpi.comparisonType;
    var isAllTime = !(effectiveFilters === null || effectiveFilters === void 0 ? void 0 : effectiveFilters.some(function (filter) { return sdk_model_1.isDateFilter(filter) && !sdk_model_1.isAllTimeDateFilter(filter); }));
    if (comparison === "none" || isAllTime || !kpiWidget.dateDataSet) {
        return undefined;
    }
    if (comparison === "previousPeriod") {
        return sdk_model_1.newPreviousPeriodMeasure(primaryMeasure, [{ dataSet: kpiWidget.dateDataSet, periodsAgo: 1 }]);
    }
    if (comparison === "lastYear") {
        var relevantDateDataset = dateDatasetsMap.get(kpiWidget.dateDataSet);
        ts_invariant_1.default(relevantDateDataset, "Cannot find relevant date dataset in useKpiData");
        var yearAttribute = relevantDateDataset.dateAttributes.find(function (dateAttribute) { return dateAttribute.granularity === "GDC.time.year"; });
        ts_invariant_1.default(yearAttribute, "Cannot find yearAttribute in useKpiData");
        return sdk_model_1.newPopMeasure(primaryMeasure, yearAttribute.attribute.ref);
    }
    ts_invariant_1.default(false, "Unknown comparison " + comparison);
}
//# sourceMappingURL=useKpiData.js.map